import {WebCallService} from "@/utilities/system/services/WebCallService";
import {PathHelper} from "@/utilities/system/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/system/enums/Enums";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import {PlantRequest} from "@/models/api/requests";
import {Plant} from "@/models/entities/plants/Plant";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";
import { ResponseValidator } from "@/utilities/system/helpers/ResponseValidator";

export class PlantService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;
    private responseValidator: ResponseValidator;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
        this.responseValidator = new ResponseValidator();
    }

    public async getPlants(errorLocationType:ErrorLocationType):Promise<Array<Plant>|null> {
        const uri = this.uriHelper.plants.getPlantsPath();

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (!this.responseValidator.ValidateResponse(resp)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async getPlantById(id:string, errorLocationType:ErrorLocationType):Promise<Plant|null> {
        const uri = this.uriHelper.plants.getPlantByIdPath(id);

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (!this.responseValidator.ValidateResponse(resp)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async addOrUpdatePlant(plant:Plant, errorLocationType:ErrorLocationType):Promise<Plant|null> {
        const uri = NullOrUndefinedHelper(plant.id)
            ? this.uriHelper.plants.getPlantsPath()
            : this.uriHelper.plants.getPlantByIdPath(plant.id);

        const requestBody = new PlantRequest(plant);

        const reqType = NullOrUndefinedHelper(plant.id)
            ? HttpType.post
            : HttpType.put;

        const resp = await this.webCaller.HttpSend(reqType, uri, requestBody);
        if (!this.responseValidator.ValidateResponse(resp)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async deletePlant(id:string, errorLocationType:ErrorLocationType):Promise<""|null> {
        const uri = this.uriHelper.plants.getPlantByIdPath(id);

        const resp = await this.webCaller.HttpSend(HttpType.delete, uri);
        if (!this.responseValidator.ValidateResponse(resp)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async postPlantCsvImport(file:File, errorLocationType:ErrorLocationType):Promise<{}|null> {
        const uri = this.uriHelper.plants.getPlantImportPath();
        const requestBody = new FormData();
        requestBody.append("locationCsvFile", file);

        const resp = await this.webCaller.HttpSend(HttpType.post, uri, requestBody);
        if (!this.responseValidator.ValidateResponse(resp)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp
    }
}